import * as React from 'react';
import { Loader } from "@progress/kendo-react-indicators";

const Loading = () => {
   
    return(  
    // <div className="k-loading-mask">
    //     <div className="k-loading-image"></div>
    //     <div className="k-loading-color"></div>
    // </div>
    <div>
    <div className="popup">
        <div>
            <Loader type="infinite-spinner" size="large" />
        </div>
    </div>
    </div>
    )

}

export default Loading;
/*
const Loading = () => {
   
    return(  
    <div className='loading-holder'>
        <Loader type="infinite-spinner" size="large"/>
    </div>
    )

}

export default Loading;
*/
